import {Component, OnInit} from '@angular/core';
import {authPasswordFlowConfig} from "../../../../../service/service";
import {HttpErrorResponse} from "@angular/common/http";
import {FormControl, FormGroup} from "@angular/forms";
import {Snackbar} from "../../../../../util/snackbar";
import {CustomOAuthService} from "../../../../../service/custom-oauth-service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-super-refresh',
  templateUrl: './super-refresh.component.html',
  styleUrls: ['./super-refresh.component.scss']
})
export class SuperRefreshComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private oauthService: CustomOAuthService,
    private snackBar: Snackbar,
  ) {
  }

  valForm: FormGroup = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
  });

  logando: boolean;

  ngOnInit() {
    const claims = this.oauthService.getIdentityClaims();
    console.log(claims);
    this.valForm.patchValue({
      email: claims.details.username
    });
  }

  submitForm($ev, value: any) {
    this.logando = true;
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.loginWithPassword(value.email, value.password);
    } else {
      this.logando = false;
    }
  }

  private loginWithPassword(user: string, password: string) {
    this.oauthService.configure(authPasswordFlowConfig);
    this.oauthService
      .fetchTokenUsingPasswordFlow(user, password).then((resp) => {
      this.openSnackBar("Usuário logado com sucesso!", "success");
      this.oauthService.setIdentityClaims();
      this.activeModal.close('logou');
    }).catch((err: HttpErrorResponse) => {
      if (err.status == 400) {
        this.openSnackBar("Usuário ou senha incorretos", "erro");
        this.logando = false;
      } else {
        this.openSnackBar("Não foi possível conectar", "erro");
        this.logando = false;
      }
    });
  }

  openSnackBar(mensagem: string, tipo: string) {
    this.snackBar.open(mensagem, tipo);
  }


}
